var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_vm._m(0),_c('router-link',{staticClass:"join-us-button",attrs:{"to":"/join-us"}},[_vm._v("انضم الينا الأن")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-above-button"},[_vm._v(" انضم لفريقنا وكن نبضاً من نبضات حبر أون لاين واجعل حبرك يخط إبداعك في أي مجال ترغبه وتبدع بالكتابة فيه من العلوم والآداب والمهارات العامة "),_c('p',[_vm._v("😊")])])
}]

export { render, staticRenderFns }